import React from "react";
import { Trash2 } from "lucide-react";
import { useDelayedUnmount } from "../../../hooks/useDelayedUnmount";
import { useLastPresentValue } from "../../../hooks/useLastPresentValue";

// 连线右键菜单（仅删除操作）
export default function EdgeContextMenu({ menu, onDelete, onClose }) {
  // 出场动画：延迟卸载（缓存 menu 供退场渲染）
  const { mounted, exiting } = useDelayedUnmount(!!menu, 150);
  // 缓存最后一份 menu，供退场动画渲染最后一帧
  const effectiveMenu = useLastPresentValue(menu);
  if (!mounted || !effectiveMenu) return null;

  return (
    <div
      className={`fixed z-50 ${exiting ? "animate-out fade-out zoom-out-95 duration-150" : "animate-in fade-in zoom-in-95 duration-150"}`}
      style={{ left: effectiveMenu.x, top: effectiveMenu.y }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="rounded-lg py-1 min-w-[140px]"
        style={{
          backgroundColor: 'var(--color-bg-secondary)',
          border: '1px solid var(--color-border-primary)',
          boxShadow: 'var(--shadow-dropdown)',
        }}
      >
        <button
          className="w-full px-3 py-1.5 flex items-center gap-2 text-left text-xs transition-colors duration-150 rounded-md"
          style={{ color: 'var(--color-text-muted)' }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--color-bg-tertiary)'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          onClick={() => {
            onDelete(effectiveMenu.edge);
            onClose();
          }}
        >
          <Trash2 size={16} />
          <span>删除连线</span>
        </button>
      </div>
    </div>
  );
}
